// extracted by mini-css-extract-plugin
export default {"color-picker":"ColorPicker_color-picker__OEMF1","colors":"ColorPicker_colors__C4rkc","selected":"ColorPicker_selected__FsyOA"};